import { ServiceMode } from 'generated/graphql-gateway';
export { ServiceMode };

export type ServiceModeStatus = {
  [key in ServiceMode]: {
    /**
     * store is available in MDM
     */
    capable: boolean;
    /**
     * store is available if store hours are within service mode availability
     * and the store supports this service mode type
     */
    available: boolean;
    /**
     * state is disabled based on flag from LD, separate from store's availability
     */
    disabled: boolean;
    /**
     * store hours are open within service mode availability
     */
    open?: boolean;
    /**
     * If today's opening hours are not set, it'll contain tomorrow's opening hours (which could be `null`).
     * If set and the store hasn't opened yet, contains the opening hours for the current;
     * otherwise, contains the opening hours for tomorrow.
     */
    nextOpeningHours: string | null;
  };
};
